<ng-template #showVerifyAccountModal let-modal>
    <div class="modal-body">
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="text-center">
            <div class="font-b1 font-bold mb-2">
                Verficá tu número
            </div>
            <div *ngIf="isVerifyEmail">
                <app-verify-email-form></app-verify-email-form>
            </div>
            <div *ngIf="!isVerifyEmail">
                <app-verify-phone-form></app-verify-phone-form>
            </div>
        </div>
    </div>
</ng-template>
